<template>
  <v-container>
    <v-row>
      <v-icon v-if="viewIcon" :color="colorClass" class="pr-2 pb-1">{{
        icon.circle
      }}</v-icon>
      <span :class="textClass">{{ status.descripcion }}</span>
    </v-row>
  </v-container>
</template>

<script>
import { mdiCheckboxBlankCircle } from '@mdi/js'

export default {
  name: 'DocumentStatus',
  props: {
    status: {
      type: Object,
      required: true
    },
    viewIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      icon: {
        circle: mdiCheckboxBlankCircle
      }
    }
  },
  computed: {
    textClass() {
      return this.status.descripcion == 'Firmado'
        ? 'teal--text text--darken-1'
        : 'red--text'
    },
    colorClass() {
      return this.status.descripcion == 'Firmado' ? 'teal darken-1' : 'red'
    }
  }
}
</script>
